export const defaultPortalsPublish = {
  portal_wiggot: true,
  portal_monopolio: true
}

export const delayedPublicationPortals = [
  'EXCELSIOR',
  'PORTALTERRENOCOM',
  'PROPIEDADESCOM',
  'LAMUDI',
  'CyT'
]
